import type { Logger } from "@expert/logging";
import type { QuizChallenge } from "@expert/sales-tools";
import type { ContentfulClientApi } from "contentful";

import type { Question } from "../../types";

import { getQuestionFromContentful } from "./getContentfulQuestion";

export const getSingleQuestionnaireQuestion = async (
    loggerParam: Logger,
    questionId: string,
    client: ContentfulClientApi<undefined>,
): Promise<Question | undefined> => {
    const logger = loggerParam.child({ module: "questionnaire" });
    try {
        return await getQuestionFromContentful(questionId, client);
    } catch (error) {
        logger.warn({ error }, "error when fetching question");
    }
};

export const determineRandomQuestion = (quizChallenge: QuizChallenge) => {
    if (!quizChallenge.metadata || quizChallenge.metadata?.questionList == null) {
        return "";
    }
    const questionIdList = quizChallenge.metadata.questionList.map((question) => question.questionId);
    const answeredQuestions = quizChallenge.answeredQuestions;
    const unanswered = questionIdList
        .filter((question) => !answeredQuestions?.find((answer) => answer.questionId === question))
        .map((question) => question);
    if (unanswered.length > 0) {
        return unanswered[Math.floor(Math.random() * unanswered.length)];
    }
    const incorrectAnswersOnly = questionIdList.filter(
        (question) => !answeredQuestions?.find((answer) => answer.questionId === question && answer.isCorrectAnswer),
    );
    if (incorrectAnswersOnly.length === 0) {
        return "";
    }
    const incorrectCounts: { question: string; count: number }[] = [];
    incorrectAnswersOnly.forEach((question) => {
        const incorrectCount = {
            question: question,
            count:
                answeredQuestions?.filter((answer) => answer.questionId === question && !answer.isCorrectAnswer)
                    .length ?? 0,
        };
        incorrectCounts.push(incorrectCount);
    });
    incorrectCounts.sort((a, b) => a.count - b.count);
    const minAnswersOnly = incorrectCounts.filter((question) => question.count === incorrectCounts[0].count);
    return minAnswersOnly[Math.floor(Math.random() * minAnswersOnly.length)].question;
};
